const ths = [
  {
    id: 1,
    label: 'Action Requested',
    intlKey: 'table.action_requested'
  },
  {
    id: 2,
    label: 'Advice',
    intlKey: 'table.advice'
  },
  {
    id: 3,
    label: 'Email',
    intlKey: 'table.email',
    sortable: true,
    sortableId: 'email'
  },
  {
    id: 4,
    label: 'Reason',
    intlKey: 'table.reason',
    sortable: true,
    sortableId: 'note'
  },
  {
    id: 5,
    label: 'Participant Name',
    intlKey: 'table.participant_name',
    sortable: true,
    sortableId: 'participant.name'
  },
  {
    id: 6,
    label: 'Participant ID',
    intlKey: 'table.participant_id',
    sortable: true,
    sortableId: 'participant.id'
  },
  {
    id: 7,
    label: 'Date',
    intlKey: 'table.Date',
    sortable: true,
    sortableId: 'sendDate'
  },
  {
    id: 8,
    label: 'Action',
    intlKey: 'table.action'
  },
]

export default ths
